export const projects = [
  {
    id: 1,
    name: "BlockTrace",
    url: "https://block-trace.net",
    github: "https://github.com/Babatems/blocktrace.git",
    image: "/images/blocktrace.png",
    description: "BlockTrace is a cutting-edge blockchain explorer that provides users with real-time insights into blockchain transactions, blocks, and addresses. Basically it converts boring blockchain data into an intuitive interface. BlockTrace makes it easy to explore and analyze blockchain data across multiple networks.",
    techStack: ["React", "Tailwind CSS", "Node.js", "Python", "Alchemy API"],
    category: "Blockchain",
    year: "2025"
  },
  {
    id: 2,
    name: "Owó-mi",
    url: "https://owo-mi-five.vercel.app/",
    github: "https://github.com/Babatems/Owo-mi",
    image: "/images/owo-mi.png",
    description: "A Canadian-focused personal finance management platform with expense/income tracking, budget management, savings goals, and optional bank account integration.",
    techStack: ["Next.js", "TypeScript", "Supabase", "Drizzle ORM", "Plaid"],
    category: "Finance",
    year: "2026"
  },
  {
    id: 3,
    name: "XIVBrand E-commerce Website",
    url: "https://thexivbrand.netlify.app",
    github: "https://github.com/Babatems/E-Commerce-Website",
    image: "/images/thexivbrand.png",
    description: "A modern and responsive e-commerce website built for XIVBrand, featuring product listings, a shopping cart system, and a clean, user-friendly design. The site emphasizes smooth navigation, interactive UI elements, and a minimal aesthetic tailored for a fashion brand.",
    techStack: ["HTML", "JavaScript", "CSS"],
    category: "E-Commerce",
    year: "2022"
  },
  {
    id: 4,
    name: "TouringCars",
    url: "https://touringcars.netlify.app",
    github: "https://github.com/Babatems/Touring-cars",
    image: "/images/touringcars.png",
    description: "A clean and welcoming landing page designed for a car rental service. The page features a modern design with intuitive navigation, showcasing the company's services, fleet of vehicles, and contact information in a visually appealing manner.",
    techStack: ["React", "Tailwind CSS"],
    category: "Landing Page",
    year: "2025"
  },
  {
    id: 5,
    name: "Travling!",
    url: "https://travlingg.netlify.app",
    github: "https://github.com/Babatems/Travling",
    image: "/images/Travling.png",
    description: "Travling is a sleek and user-friendly landing page that allows users to discover exciting vacation destinations, book hotel accommodations, and purchase flight tickets, all in one place.",
    techStack: ["React", "Tailwind CSS"],
    category: "Landing Page",
    year: "2025"
  },
  {
    id: 6,
    name: "Password Generator",
    url: "https://password-generator-9a40df.netlify.app/",
    github: "https://github.com/Babatems/Password-Generator",
    image: null,
    description: "A browser-based password generator that creates secure, randomized passwords on demand. Users can customize length and character types — uppercase, lowercase, numbers, and symbols — to meet any security requirement without relying on third-party tools.",
    techStack: ["HTML", "CSS", "JavaScript"],
    category: "Tools",
    year: "2022"
  },
  {
    id: 7,
    name: "Chrome Extension",
    url: null,
    github: "https://github.com/Babatems/Chrome-Extension",
    image: null,
    description: "A lightweight Chrome extension for capturing and storing URLs during browsing sessions. Saves site links locally for later review and data analysis, making it easy to track research sources or monitor web activity across multiple sites.",
    techStack: ["HTML", "CSS", "JavaScript"],
    category: "Tools",
    year: "2022"
  }
];
